import { Download } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useInstallPrompt } from '@/hooks/useInstallPrompt';
import { useInstallTracking } from '@/hooks/useInstallTracking';
import { useTranslation } from 'react-i18next';

const EXCLUDED_ROUTES = ['/agendar', '/instalar', '/admin'];

const InstallFAB = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const { isInstallable, isInstalled, promptInstall } = useInstallPrompt();
  const { track } = useInstallTracking();

  if (isInstalled || EXCLUDED_ROUTES.includes(location.pathname)) return null;

  const handleClick = async () => {
    track('fab_clicked');
    if (isInstallable) {
      const accepted = await promptInstall();
      if (accepted) track('install_success', { source: 'fab' });
    } else {
      navigate('/instalar');
    }
  };

  return (
    <button
      onClick={handleClick}
      className="fixed bottom-[5.5rem] right-6 z-40 p-3 md:p-4 rounded-full bg-gradient-to-r from-primary to-primary/80 shadow-lg hover:shadow-xl hover:scale-110 transition-all duration-300 animate-bounce-slow group min-w-[48px] min-h-[48px] flex items-center justify-center"
      aria-label={t('install.fab.tooltip', 'Install App')}
    >
      <Download className="w-5 h-5 md:w-6 md:h-6 text-primary-foreground" aria-hidden="true" />
      
      {/* Tooltip */}
      <span className="absolute bottom-full right-0 mb-2 px-3 py-2 bg-card text-primary text-sm font-medium rounded-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap shadow-lg pointer-events-none" role="tooltip">
        {t('install.fab.tooltip', 'Install App')}
        <span className="tooltip-arrow" />
      </span>
    </button>
  );
};

export default InstallFAB;
